import React, { useCallback, useMemo, useRef, useState } from 'react'
import classes from './style.module.scss'
import useStyles from 'isomorphic-style-loader/useStyles'
import { FormattedMessage, useIntl } from 'react-intl'
import { unitPrice } from '../../../../../../../utils/product'
import { BigButton } from '../../../../../../components/button'
import useCheckoutButton from '../../hooks/checkout-button'
import PaypalButton from '../../../../components/paypal-button'
import ApplePayButton from '../../../../components/applepay-button'
import GooglePayButton from '../../../../components/google-button'
import StayAlert from '../../../bag/fragments/stay-alert'
import { useSelector } from 'react-redux'
import Cache from '../../../../../../../utils/cache'
import { useHistory } from 'react-router'
import deeplink from '../../../../../../../utils/deeplink'
import { getSensorsUrl } from '../../../../../../utils/sensor'
import SafechargeApplePay from '../../../../components/safecharge/applepay'
import SafechargeGooglePay from '../../../../components/safecharge/google'
import AfterPayCashAppPay from '../../../../components/cash-app-pay'
import PopupPrompt from '../../../../components/prompt'
import { testPhone, testZip } from '../../../../validator'
import Alert from '../../../../../../components/alert/index'
import FacebookEvents from '../../../../../../ads/events/facebook'
import StripeKlarnaButton from '../../../../components/stripe-klarna-button'
import StripeIdealButton from "../../../../components/stripe-ideal-button";
import {Iconfont} from "../../../../../../components/icon/iconfont";
import TotalDiscountPopup from "../../../bag/fragments/total-discount-popup";

export default props => {
    useStyles(classes)
    const { orderTotal, saved, payMethod, onError, klarnas, shippingDetail, onCouponHandle, showStayAlert, setShowStayAlert, selectedCard, buttonPopups, payMethodTaxAmount,orderSummary,quickBuy } = props
    const history = useHistory()
    const global = useSelector(state => state.global)
    const checkRef = useRef()
    const [showStripeIdeal, setShowStripeIdeal] = useState(false)
    const [showTotalPopup, setShowTotalPopup] = useState(false);
    const {
        paying,
        pay
    } = useCheckoutButton({
        klarnas,
        payMethod,
        onError,
        selectedCard,
        setShowStripeIdeal
    })

    const {
        checkout
    } = useSelector(state => state.pageCart)

    const Intl = useIntl();

    const count = useMemo(() => {
        return checkout?.parcels?.reduce((prev, curr) => {
            return prev + curr?.itemCount
        }, 0)
    }, [checkout])

    const productIds = useMemo(() => {
        return checkout?.parcels?.reduce((prev, curr) => {
            return [...prev, ...curr?.billingProducts?.map(item => item?.productId)]
        }, [])
    }, [checkout])


    const clickHandle = () => {

        FacebookEvents.initiateCheckout({
            content_ids: productIds,
            currency: orderTotal?.currency,
            num_items: count,
            value: orderTotal?.amount
        })

        if (!shippingDetail) {
            onError({ type: 'no_shipping' })
        } else if (!testZip(shippingDetail.zipCode, shippingDetail.country?.value) || !testPhone(shippingDetail.phoneNumber, shippingDetail.country?.value)) {
            onError({ type: 'validate_shipping' })
        } else if (!payMethod) {
            onError({ type: 'no_paymethod' })
        } else {
            pay()
        }

    }

    const eventClick = () => {
        FacebookEvents.initiateCheckout({
            content_ids: productIds,
            currency: orderTotal?.currency,
            num_items: count,
            value: orderTotal?.amount
        })
    }

    checkRef.current = () => {
        if (!testZip(shippingDetail.zipCode, shippingDetail.country?.value) || !testPhone(shippingDetail.phoneNumber, shippingDetail.country?.value)) {
            onError({ type: 'validate_shipping' })
            return false
        }
        return true
    }

    const checkShippingHandle = () => {
        return checkRef.current()
    }

    const backHandle = (sensors) => {
        Cache.set('retention_type', checkout?.retentionPromptWin?.type)
        if (window.GeekoSensors) {
            window.GeekoSensors.Track("Popup_Stay", {
                action: "离开下单页",
                ...sensors
            })
        }
        setShowStayAlert(false)
        // if (document.referrer?.indexOf(global.config?.domain) < 1) {
        //     history.go(-4)
        // } else {
        history.goBack()
        // }
    }

    const closeHandle = (sensors) => {
        Cache.set('retention_type', checkout?.retentionPromptWin?.type)
        if (window.GeekoSensors) {
            window.GeekoSensors.Track("Popup_Stay", {
                action: "停留下单页",
                ...sensors
            })
        }
        setShowStayAlert(false)
    }

    const deepLinkHandle = (deepLink, sensors) => {
        Cache.set('retention_type', checkout?.retentionPromptWin?.type)
        setShowStayAlert(false)
        if (deepLink.type === 44) {
            if (window.GeekoSensors) {
                window.GeekoSensors.Track("Popup_Stay", {
                    action: "下单",
                    ...sensors
                })
            }
            clickHandle()
        } else if (deepLink.type === 45) {
            if (window.GeekoSensors) {
                window.GeekoSensors.Track("Popup_Stay", {
                    action: "coupon",
                    ...sensors
                })
            }
            onCouponHandle()
        } else {
            if (window.GeekoSensors) {
                window.GeekoSensors.Track("Popup_Stay", {
                    action: "离开下单页",
                    ...sensors
                })
            }
            const url = deeplink(deepLink, "msite")
            window.location.href = getSensorsUrl(url, sensors)
        }
    }

    const handleBrTaxAlert = useCallback(() => {
        Alert(Intl.formatMessage({ id: 'local_policy_pay_tax', defaultMessage: 'According to local policy, customers will need to pay a tax on foreign exchange transactions when choosing this payment method.' }));
    }, []);

    const usePaypalButton = payMethod?.type === '1' && !!shippingDetail
    const useAppleButton = payMethod?.type === '32' && !!shippingDetail
    const useGoogleButton = payMethod?.type === '41' && !!shippingDetail
    const useSafechargeApplePay = payMethod?.type === '42' && !!shippingDetail
    const useSafechargeGooglePay = payMethod?.type === '43' && !!shippingDetail
    const useCashAppPay = payMethod?.type === '44' && !!shippingDetail
    // const useStripeKlarna=payMethod?.type === '27' && !!shippingDetail
    const useStripeKlarna=false


    return <><div className={`${classes.Container} ${usePaypalButton ? classes.Height100 : ""}`}>

        {
            !!buttonPopups && <React.Fragment>
                <PopupPrompt
                    buttonPopups={buttonPopups}
                    className={`${classes.PopupPromptNormal} ${usePaypalButton ? classes.PopupPromptPaypal : ""}`}
                />
            </React.Fragment>
        }

        <div className={`${classes.PlaceOrder} ${!usePaypalButton ? classes.Double : ''}`}>
            <div className={classes.OrderSummaryDiv}  onClick={()=>{ setShowTotalPopup(state => !state)}}>
                <div className={`${classes.OrderSummary}`}>
                    <div className={classes.Total}>
                        <span className={classes.Label}><FormattedMessage id="total" defaultMessage="Total" />:{' '}</span>
                        <span className={classes.Value}>{unitPrice(orderTotal)}</span>
                        {quickBuy&&<Iconfont className={`${classes.Jt}`}>&#xe779;</Iconfont>}

                        {
                            !!payMethodTaxAmount && <span className={classes.PayMethodTax}>
                                <span className={classes.TaxLabel}>&nbsp;+&nbsp;{unitPrice(payMethodTaxAmount)}&nbsp;</span>
                                <span className={classes.Ask} onClick={handleBrTaxAlert}>?</span>
                            </span>
                        }
                    </div>
                    {
                        saved && <div className={classes.Saved}>
                            <span className={classes.Label}><FormattedMessage id="saved" defaultMessage="Saved" />:{' '}</span>
                            <span className={classes.Value}>{unitPrice(saved)}</span>
                        </div>
                    }
                </div>
            </div>

            <div className={classes.Buttons}>
                {
                    usePaypalButton && <PaypalButton clickHandle={eventClick} check={checkShippingHandle} onError={onError} className={classes.PaypalButton} />
                }

                {
                    useAppleButton && <ApplePayButton clickHandle={eventClick} check={checkShippingHandle} onError={onError} payMethod={payMethod?.id} orderTotal={orderTotal} country={shippingDetail?.country?.value} />
                }

                {
                    useGoogleButton && <GooglePayButton clickHandle={eventClick} check={checkShippingHandle} onError={onError} payMethod={payMethod?.id} orderTotal={orderTotal} country={shippingDetail?.country?.value} />
                }

                {
                    useSafechargeApplePay && <SafechargeApplePay clickHandle={eventClick} check={checkShippingHandle} onError={onError} payMethod={payMethod?.id} orderTotal={orderTotal} country={shippingDetail?.country?.value} />
                }

                {
                    useSafechargeGooglePay && <SafechargeGooglePay clickHandle={eventClick} check={checkShippingHandle} onError={onError} payMethod={payMethod?.id} orderTotal={orderTotal} country={shippingDetail?.country?.value} />
                }

                {
                    useCashAppPay && <AfterPayCashAppPay clickHandle={eventClick} check={checkShippingHandle} content={<FormattedMessage id="place_order" defaultMessage="Place Order" />} className={classes.CheckoutButton} onError={onError} payMethod={payMethod?.id} orderTotal={orderTotal} country={shippingDetail?.country?.value} />
                }
                {
                    useStripeKlarna&&<StripeKlarnaButton clickHandle={eventClick} check={checkShippingHandle} onError={onError} payMethod={payMethod?.id} orderTotal={orderTotal} country={shippingDetail?.country?.value} />
                }
                {
                    !usePaypalButton && !useAppleButton && !useGoogleButton && !useSafechargeApplePay && !useSafechargeGooglePay && !useCashAppPay&&!useStripeKlarna && <BigButton loading={paying} className={classes.CheckoutButton} onClick={clickHandle}>
                        <FormattedMessage id="place_order" defaultMessage="Place Order" />
                    </BigButton>
                }
                {
                    checkout?.retentionPromptWin && <StayAlert
                        serverTime={checkout?.serverTime}
                        retentionPromptWin={checkout?.retentionPromptWin}
                        onLeave={backHandle}
                        onClose={closeHandle}
                        onDeepLink={deepLinkHandle} show={showStayAlert} />
                }
                {
                    showStripeIdeal&&<StripeIdealButton clickHandle={eventClick} check={checkShippingHandle} onError={onError} payMethod={payMethod?.id} orderTotal={orderTotal} country={shippingDetail?.country?.value} setShowStripeIdeal={setShowStripeIdeal}/>
                }

            </div>
        </div>
        </div>
        {quickBuy&&<TotalDiscountPopup show={showTotalPopup} onClose={() => setShowTotalPopup(false)} summary={orderSummary} importantFontSize={true} paddingBottom100={true}  />}
        </>
}